module.exports = __webpack_public_path__ + "img/swj1.0a733fd2.jpg";